import { mesaColorNames, fontFamilies } from '@/src/common/theme'
import { Text } from 'react-native'

export const CardBenefitsComponentsSummary = ({ summary }: { summary: string }) => (
  <Text
    style={{
      color: mesaColorNames['Greyscale/900 #152438'],
      marginBottom: 16,
      fontSize: 14,
      lineHeight: 21,
      fontFamily: fontFamilies['PlusJakartaSans-Regular'],
      fontWeight: 400,
    }}
  >
    {summary}
  </Text>
)
